import "../styles/CurriculumNeedHelpStyles.css";
import strings from "../../../utils/Strings";
import GreenImg from "../assets/needhelp/uptrend.png";
import YellowImg from "../assets/needhelp/neutraltrend.png";
import RedImg from "../assets/needhelp/downtrend.png";
import Overallimg from "../assets/needhelp/step2.svg";
import ConceptPerformance from "../assets/needhelp/step3.svg";
import ViewDetailedInsights from "../assets/needhelp/detailedinsigts.svg";
import OverallTooltip from "../assets/needhelp/overalltabtooltip.svg";
import ConceptTooltip from "../assets/needhelp/concepttooltip.svg";
import ProgressTooltip from "../assets/needhelp/progresstimeline.svg";
import DropdownImg from "../assets/needhelp/advancefilterneedhelp.svg";
import { useEffect, useRef, useState } from "react";
import AccordionComponent from "./AccordionComponent";
import ScrollUpButton from "../assets/needhelp/scrollup.svg";
import ScrollDownButton from "../assets/needhelp/scrolldown.svg";
import { RightModalProps } from "./DashboardNeedHelp";
const CurriculumProgramNeedHelpComponent: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [viewdetailsshowTooltip, setviewdetailedShowTooltip] = useState(false);
  const [progresstimeline, setProgresstimeline] = useState(false);
  const [overallprogress, setOverallProgress] = useState(false);
  const [conceptPerformance, setconceptperformance] = useState(false);
  const [profviewDetail, setprofviewDetail] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        const tolerance = 10; // Larger tolerance to handle edge cases

        setIsScrolledToTop(scrollTop <= tolerance);
        setIsScrolledToBottom(
          scrollTop + clientHeight >= scrollHeight - tolerance,
        );
      }
    };
    const refCurrent = contentRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    handleScroll();

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScrollDown = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const handleScrollUp = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: -1000, behavior: "smooth" });
    }
  };

  return (
    <div className="currneedhelpcontainer" ref={contentRef}>
      <AccordionComponent
        title={strings.dashboardNeedHelp.currskillPerformance.headerText}
      >
        {/* Top container row grid */}
        <div className="curr-needhelp-left-firstsubcon">
          <div className="curr-needhelp-left-firstsubcon-row">
            <div className="curr-needhelp-skillsovers">
              <div className="curr-needhelp-skills1">
                <span
                  className="curr-needhelp-left-headtext"
                  style={{ paddingRight: "5px" }}
                >
                  {" "}
                  {
                    strings.dashboardNeedHelp.currskillPerformance
                      .curriculumastery
                  }
                </span>
                {
                  strings.dashboardNeedHelp.currskillPerformance
                    .curriculumasteryexp
                }
              </div>
            </div>
            <div className="curr-needhelp-skillsovers">
              <div className="curr-needhelp-skills1">
                <span
                  className="curr-needhelp-left-headtext"
                  style={{ paddingRight: "5px" }}
                >
                  {" "}
                  {
                    strings.dashboardNeedHelp.currskillPerformance
                      .professionalreadiness
                  }
                </span>
                {
                  strings.dashboardNeedHelp.currskillPerformance
                    .professionalreadinessexp
                }
              </div>
            </div>
          </div>
        </div>
      </AccordionComponent>
      <AccordionComponent
        title={strings.dashboardNeedHelp.currskillPerformance.trendlineQs}
      >
        {/* Left section First container -Trendlines and Colors */}
        <div className="curr-needhelp-left-second">
          {/* Header answer2 text */}
          <div className="curr-needhelp-top-subtext">
            {strings.dashboardNeedHelp.currskillPerformance.answer}
          </div>
          {/* 1st con */}
          <div className="curr-needhelp-left-secondsubcon">
            <div
              className="curr-needhelp-leftrendover"
              // style={{ backgroundColor: "#E3FFF5" }}
            >
              <div className="curr-needhelp-trendtextskills">
                {strings.dashboardNeedHelp.jozunaskillPerformance.upwardtrend}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  gap: "10px",
                }}
              >
                <img
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "20px",
                    width: "20px",
                    marginTop: "4px",
                  }}
                  src={GreenImg}
                  alt="trend"
                />
                <div
                  className="curr-needhelp-skillscount"
                  style={{ color: "#00A862" }}
                >
                  {
                    strings.dashboardNeedHelp.jozunaskillPerformance
                      .countzerozero
                  }
                </div>
              </div>
            </div>
            {/* Upward Exp */}
            <div
              className="curr-needhelp-trendover"
              style={{
                backgroundColor: "#ffffff",
                width: "100%",
              }}
            >
              <div className="curr-needhelp-top-subtext">
                {strings.dashboardNeedHelp.currskillPerformance.upwardtrendexp}
              </div>
            </div>
          </div>
          {/* 2nd con */}
          <div className="curr-needhelp-left-secondsubcon">
            <div
              className="curr-needhelp-leftrendover"
              //style={{ backgroundColor: "#FFF8DB" }}
            >
              <div className="curr-needhelp-trendtextskills">
                {strings.dashboardNeedHelp.jozunaskillPerformance.neutraltrend}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  gap: "10px",
                }}
              >
                <img
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "20px",
                    width: "20px",
                    marginTop: "4px",
                  }}
                  src={YellowImg}
                  alt="trend"
                />
                <div
                  className="curr-needhelp-skillscount"
                  style={{ color: "#C08A23" }}
                >
                  {
                    strings.dashboardNeedHelp.jozunaskillPerformance
                      .countzerozero
                  }
                </div>
              </div>
            </div>
            {/* Neutral Exp */}
            <div
              className="curr-needhelp-trendover"
              style={{
                backgroundColor: "#ffffff",
                width: "100%",
              }}
            >
              <div className="curr-needhelp-top-subtext">
                {strings.dashboardNeedHelp.currskillPerformance.neutraltrendexp}
              </div>
            </div>
          </div>
          {/* 3rd con */}
          <div className="curr-needhelp-left-secondsubcon">
            <div
              className="curr-needhelp-leftrendover"
              // style={{ backgroundColor: "#FFDCD9" }}
            >
              <div className="curr-needhelp-trendtextskills">
                {strings.dashboardNeedHelp.jozunaskillPerformance.downwardtrend}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignContent: "center",
                  gap: "10px",
                }}
              >
                <img
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: "20px",
                    width: "20px",
                    marginTop: "4px",
                  }}
                  src={RedImg}
                  alt="trend"
                />
                <div
                  className="curr-needhelp-skillscount"
                  style={{ color: "#E84C3D" }}
                >
                  {
                    strings.dashboardNeedHelp.jozunaskillPerformance
                      .countzerozero
                  }
                </div>
              </div>
            </div>
            {/* Downward Exp */}
            <div
              className="curr-needhelp-trendover"
              style={{
                backgroundColor: "#ffffff",
                width: "100%",
              }}
            >
              <div className="curr-needhelp-top-subtext">
                {
                  strings.dashboardNeedHelp.currskillPerformance
                    .downwardtrendexp
                }
              </div>
            </div>
          </div>
        </div>
      </AccordionComponent>

      <AccordionComponent
        title={strings.dashboardNeedHelp.currskillPerformance.indivqs}
      >
        {/* Right section Second Container */}
        <div className="curr-needhelp-left-second">
          {/* Step 1 */}
          <div className="curr-needhelp-left-step">
            {strings.dashboardNeedHelp.currskillPerformance.step1}
          </div>

          {/* Step 1 content */}

          <div className="curr-needhelp-skills1">
            {strings.dashboardNeedHelp.currskillPerformance.step1exp}
            {/* <span
              className="curr-needhelp-span-bg-text"
              style={{ paddingRight: "5px" }}
              onMouseEnter={() => setviewdetailedShowTooltip(true)}
              onMouseLeave={() => setviewdetailedShowTooltip(false)}
            >
              {" "}
              {
                strings.dashboardNeedHelp.currskillPerformance
                  .viewdetailedinsights
              }
            </span> */}
            {/* {strings.dashboardNeedHelp.currskillPerformance.btnon} */}
            {/* {viewdetailsshowTooltip && (
              <div className="tooltip-container">
                <div className="tooltip-arrow"></div>
                <div className="tooltip-content">
                  <img
                    src={ViewDetailedInsights}
                    alt="Detailed insights example"
                    className="tooltip-image"
                  />
                </div>
              </div>
            )} */}
          </div>
          {/* Tooltip that appears on hover */}
          <div style={{ backgroundColor: "#7DBFD4", height: "1.5px" }}></div>

          {/* Step 2 */}
          <div className="curr-needhelp-left-firstsubcons">
            <div className="curr-needhelp-left-firstsubcol">
              <div className="curr-needhelp-left-step">
                {strings.dashboardNeedHelp.currskillPerformance.step2}
              </div>
              {/* Step 2 content */}
              <div className="curr-needhelp-skills1">
                {strings.dashboardNeedHelp.currskillPerformance.onthe}
                <span
                  className="curr-needhelp-span-bg-text"
                  style={{ paddingRight: "5px" }}
                  onMouseEnter={() => setProgresstimeline(true)}
                  onMouseLeave={() => setProgresstimeline(false)}
                >
                  {" "}
                  {
                    strings.dashboardNeedHelp.currskillPerformance
                      .progresstimeline
                  }
                </span>
                {progresstimeline && (
                  <div
                    className="tooltip-container"
                    style={{ left: "5%", bottom: "100%" }}
                  >
                    <div className="tooltip-arrow"></div>
                    <div className="tooltip-content">
                      <img
                        src={ProgressTooltip}
                        alt="Detailed insights example"
                        className="tooltip-image"
                      />
                    </div>
                  </div>
                )}
                {strings.dashboardNeedHelp.currskillPerformance.youwill}
                <span
                  className="curr-needhelp-span-bg-text"
                  style={{ paddingRight: "5px" }}
                  onMouseEnter={() => setOverallProgress(true)}
                  onMouseLeave={() => setOverallProgress(false)}
                >
                  {" "}
                  {
                    strings.dashboardNeedHelp.currskillPerformance
                      .OverallProgress
                  }
                </span>
                {strings.dashboardNeedHelp.currskillPerformance.menuthat}
                {overallprogress && (
                  <div
                    className="tooltip-container"
                    style={{ left: "45%", bottom: "100%" }}
                  >
                    <div className="tooltip-arrow"></div>
                    <div className="tooltip-content">
                      <img
                        src={OverallTooltip}
                        alt="Detailed insights example"
                        className="tooltip-image"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Overall Chart Img */}
            <div
              style={{
                display: "flex",
                width: "100%", // Changed from 50% to 100%
                height: "auto", // Changed from 100% to auto
                overflow: "hidden",
                position: "relative",
              }}
            >
              <img
                src={Overallimg}
                style={{
                  width: "100%",
                  height: "auto", // Changed from 100% to auto
                  objectFit: "contain", // Changed from cover to contain
                  objectPosition: "center",
                  display: "block",
                }}
              ></img>
            </div>
          </div>
          <div style={{ backgroundColor: "#7DBFD4", height: "1.5px" }}></div>

          {/* Step 3*/}
          <div className="curr-needhelp-left-firstsubcons">
            <div className="curr-needhelp-left-firstsubcol">
              <div className="curr-needhelp-left-step">
                {strings.dashboardNeedHelp.currskillPerformance.step3}
              </div>
              {/* Step 3 content */}
              <div className="curr-needhelp-skills1">
                {strings.dashboardNeedHelp.currskillPerformance.clickthe}
                <span
                  className="curr-needhelp-span-bg-text"
                  style={{ paddingRight: "5px" }}
                  onMouseEnter={() => setconceptperformance(true)}
                  onMouseLeave={() => setconceptperformance(false)}
                >
                  {" "}
                  {
                    strings.dashboardNeedHelp.currskillPerformance
                      .conceptperformance
                  }
                </span>
                {strings.dashboardNeedHelp.currskillPerformance.menubesides}
                {conceptPerformance && (
                  <div
                    className="tooltip-container"
                    style={{ left: "10%", bottom: "100%" }}
                  >
                    <div className="tooltip-arrow"></div>
                    <div className="tooltip-content">
                      <img
                        src={ConceptTooltip}
                        alt="Detailed insights example"
                        className="tooltip-image"
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Overall Chart Img */}
            <div className="curr-needhelp-left-firstsubimgcol">
              <div
                style={{
                  display: "flex",
                  width: "100%", // Changed from 50% to 100%
                  height: "auto", // Changed from 100% to auto
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={ConceptPerformance}
                  style={{
                    width: "100%",
                    height: "auto", // Changed from 100% to auto
                    objectFit: "contain", // Changed from cover to contain
                    objectPosition: "center",
                    display: "block",
                  }}
                ></img>
              </div>
              {/* Right section note text */}
              <div className="curr-needhelp-skills1">
                {strings.dashboardNeedHelp.currskillPerformance.note}
              </div>
            </div>
          </div>
        </div>
      </AccordionComponent>

      <AccordionComponent
        title={strings.dashboardNeedHelp.currskillPerformance.profreadinessqs}
      >
        {/* Right section main text */}
        <div className="curr-needhelp-skills1">
          {strings.dashboardNeedHelp.currskillPerformance.inthe}
          <span
            className="curr-needhelp-span-bg-text"
            style={{ paddingRight: "5px" }}
            onMouseEnter={() => setprofviewDetail(true)}
            onMouseLeave={() => setprofviewDetail(false)}
          >
            {" "}
            {
              strings.dashboardNeedHelp.currskillPerformance
                .viewdetailedinsights
            }
          </span>
          {profviewDetail && (
            <div
              className="tooltip-container"
              style={{ left: "5%", top: "0%" }}
            >
              <div className="tooltip-arrow"></div>
              <div className="tooltip-content">
                <img
                  src={ViewDetailedInsights}
                  alt="Detailed insights example"
                  className="tooltip-image"
                />
              </div>
            </div>
          )}
          {strings.dashboardNeedHelp.currskillPerformance.modalfor}
          <span
            className="curr-needhelp-span-bg-text"
            style={{ paddingRight: "5px" }}
            onMouseEnter={() => setviewdetailedShowTooltip(true)}
            onMouseLeave={() => setviewdetailedShowTooltip(false)}
          >
            {" "}
            {strings.dashboardNeedHelp.currskillPerformance.dropdowns}
          </span>
          {viewdetailsshowTooltip && (
            <div
              className="tooltip-container"
              style={{ left: "50%", top: "0%" }}
            >
              <div className="tooltip-arrow"></div>
              <div className="tooltip-content">
                <img
                  src={DropdownImg}
                  alt="Detailed insights example"
                  className="tooltip-image"
                />
              </div>
            </div>
          )}
          {strings.dashboardNeedHelp.currskillPerformance.atthetop}
          {strings.dashboardNeedHelp.currskillPerformance.youcanchoose}
        </div>
      </AccordionComponent>
      {/* Need Help Scroll Button */}
      {isOpen && (
        <div className="dashboard-scroll-buttons">
          <img
            height={"60px"}
            width={"120px"}
            src={isScrolledToBottom ? ScrollUpButton : ScrollDownButton}
            alt={isScrolledToBottom ? "Scroll Up" : "Scroll Down"}
            className="dashboard-scroll-btn"
            onClick={isScrolledToBottom ? handleScrollUp : handleScrollDown}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
    </div>
  );
};
export default CurriculumProgramNeedHelpComponent;
